namespace SorAraBul.Administration {
    export interface HasoErrorCodesRow {
        Id?: number;
        ErrorCode?: string;
        Message?: string;
        InsertDate?: string;
        UpdateDate?: string;
    }

    export namespace HasoErrorCodesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ErrorCode';
        export const localTextPrefix = 'Administration.HasoErrorCodes';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'Administration:SuperAdmin';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            ErrorCode = "ErrorCode",
            Message = "Message",
            InsertDate = "InsertDate",
            UpdateDate = "UpdateDate"
        }
    }
}
